import type { IconData } from '@stacksjs/iconify-core'

export const safari: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M29 29c-1.15 1.15-8.1 3.5-12.453 4.893a1.933 1.933 0 0 1-2.442-2.44C15.495 27.101 17.841 20.158 19 19s8.102-3.504 12.452-4.895a1.933 1.933 0 0 1 2.44 2.442C32.5 20.901 30.15 27.851 29 29M24 7v1m-12.02 3.98l.707.707M7 24h1m16 17v-1m12.02-3.98l-.707-.707M41 24h-1m-21-5l10 10\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default safari
